import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class MainSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'main');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', []),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', []),
            this.fontWeightField('bold.weight', []),
            this.fontColorComboField('font.color', []),
            this.fontColorComboField('muted.color', [], this.shadeValues('fade', 'main', 'font', [0.2, 0.35, 0.5, 0.65])),

            this.backgroundColorField('background.color', []),
            this.borderColorField('border.color', []),

            this.fontColorComboField('active.font.color', ['main', 'content']),
            this.backgroundColorField('active.background.color', ['main', 'content']),
            this.fontColorComboField('hover.font.color', ['main', 'content']),
            this.backgroundColorField('hover.background.color', ['main', 'content']),

            this.sizeNumberField('gutter.width'),

            this.dropShadowField('shadow'),

            this.fontColorComboField('icon.color', ['main', 'content'], {
                [this.translateValue('INHERIT')]: 'inherit',
                ...this.preset('muted-color', 'main'),
            }),

            this.comboField('icon.pack', {
                'Font Awesome Solid': 'fontawesome:900',
                'Font Awesome Regular': 'fontawesome:400',
                'Font Awesome Light': 'fontawesome:300',
                'Font Awesome Thin': 'fontawesome:100',
            }),            

        ];
    }

}
